// Copyright (c) 2017 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import actions from '../../action-list';
import {getApplyTravel} from '../../shared/repositories';

export const setUpdateShowApplyTravel = updateShowApplyTravel =>
    ({
        type: actions.UPDATE_CLAIM_NORMAL_UPDATE_SHOW_APPLY_TRAVEL,
        updateShowApplyTravel
    });

export const readShowApplyTravel = claim =>

    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            const useAmountArray = [];

            claim.useAmounts.every(o => useAmountArray.push(parseInt(o.amount, 10) + o.unit.key));

            const args = `account=${claim.responsibleAccount.account}&claimType=${claim.claimType.key}&pin=${claim.pin}&failurePart=${encodeURIComponent(claim.failureInfo.failurePartNumber)}&failureDate=${claim.failureInfo.failureDate}&amountOfUse=${useAmountArray.toString()}`;

            const data = await getApplyTravel(args);

            dispatch({
                showApplyTravel: data.showApplyTravel,
                type: actions.UPDATE_CLAIM_NORMAL_SHOW_APPLY_TRAVEL
            });

            if (!data.showApplyTravel) {

                dispatch({
                    applyTravel: false,
                    type: actions.UPDATE_CLAIM_NORMAL_APPLY_TRAVEL
                });

            }

        } catch (error) {

            throw error;

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

            dispatch(setUpdateShowApplyTravel(false));

        }

    };



// WEBPACK FOOTER //
// ./src/claim/normal/action-creators/get-apply-travel.js